import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";
import OAuthCallback from "@/pages/OAuthCallback";

export const Route = createFileRoute("/oauth/callback")({
  head: noindexHead,
  component: OAuthCallback,
});
